import { Map } from 'immutable';
import { ProfileActions } from '../types';
import { CompanyTechTagsState, COMPANY_TECH_TAGS_UPDATE } from './types';

const initState: CompanyTechTagsState = Map<string, any>({
  companyTechTags: null,
});

const reducer = (state = initState, action: ProfileActions) => {
  switch (action.type) {
    case COMPANY_TECH_TAGS_UPDATE:
      return state.set('companyTechTags', action.payload);
    default:
      return state;
  }
};

export { initState, reducer };
